var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"about-me-container"},[(_vm.userInfo.userBio)?_c('vue-showdown',{attrs:{"markdown":_vm.userInfo.userBio,"tag":"p"}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }